package com.evoapps.evoshift.ui.billing

import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.WorkspacePremium
import androidx.compose.material3.AlertDialog
import androidx.compose.material3.Icon
import androidx.compose.material3.Text
import androidx.compose.material3.TextButton
import androidx.compose.runtime.Composable
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.font.FontWeight
import com.evoapps.evoshift.domain.billing.PlanCheck
import com.evoapps.evoshift.domain.billing.PlanResource
import com.evoapps.evoshift.domain.billing.PlanTier
import com.evoapps.evoshift.ui.DeepNavy
import com.evoapps.evoshift.ui.LightGold
import evoshift.composeapp.generated.resources.Res
import evoshift.composeapp.generated.resources.ok
import evoshift.composeapp.generated.resources.paywall_not_now
import evoshift.composeapp.generated.resources.plan_limit_none
import evoshift.composeapp.generated.resources.plan_limit_none_ask_owner
import evoshift.composeapp.generated.resources.plan_limit_seats
import evoshift.composeapp.generated.resources.plan_limit_seats_ask_owner
import evoshift.composeapp.generated.resources.plan_limit_see_plans
import evoshift.composeapp.generated.resources.plan_limit_title
import evoshift.composeapp.generated.resources.plan_limit_workplaces
import org.jetbrains.compose.resources.stringResource

/**
 * The gate (SH-38, SH-52): the owner's plan does not allow one more person or workplace, or the
 * trial ended without a plan. The owner gets the plans ([onSeePlans]); a manager (null) is told
 * to ask the owner. What was typed stays in the form.
 */
@Composable
fun PlanLimitDialog(limit: PlanCheck.LimitReached, onSeePlans: (() -> Unit)?, onDismiss: () -> Unit) {
    val owner = onSeePlans != null
    val message = when {
        limit.tier == PlanTier.NONE -> stringResource(if (owner) Res.string.plan_limit_none else Res.string.plan_limit_none_ask_owner)
        limit.resource == PlanResource.WORKPLACES -> stringResource(Res.string.plan_limit_workplaces, limitLabel(limit.limit))
        else -> stringResource(if (owner) Res.string.plan_limit_seats else Res.string.plan_limit_seats_ask_owner, limitLabel(limit.limit))
    }
    AlertDialog(
        onDismissRequest = onDismiss,
        containerColor = DeepNavy,
        icon = { Icon(Icons.Default.WorkspacePremium, contentDescription = null, tint = LightGold) },
        title = { Text(stringResource(Res.string.plan_limit_title), color = LightGold) },
        text = { Text(message, color = Color.White.copy(alpha = 0.85f)) },
        confirmButton = {
            if (onSeePlans != null) {
                TextButton(onClick = onSeePlans) {
                    Text(stringResource(Res.string.plan_limit_see_plans), color = LightGold, fontWeight = FontWeight.Bold)
                }
            } else {
                TextButton(onClick = onDismiss) { Text(stringResource(Res.string.ok), color = LightGold, fontWeight = FontWeight.Bold) }
            }
        },
        dismissButton = {
            if (onSeePlans != null) {
                TextButton(onClick = onDismiss) { Text(stringResource(Res.string.paywall_not_now), color = Color.White) }
            }
        }
    )
}
